import { LoginComponent } from '@app/account/login/login.component';
import { MainmenuComponent } from './mainmenu/mainmenu.component';
import { ContactComponent } from './contact/contact.component';
import { ContactReportComponent } from './contact-report/contact-report.component';
import { ChatbotComponent } from './chatbot/chatbot.component';
import { SocialMediaMonitorComponent } from './social-media-monitor/social-media-monitor.component';
import { ReportComponent } from './report/report.component';
import { NewsComponent } from './news/news.component';
import { FinancialInstitutionComponent } from './financial-institution/financial-institution.component';
import { SimulatorComponent } from './simulator/simulator.component';
import { RefundComponent } from './refund/refund.component';
import { ContactDpaComponent } from './contact-dpa/contact-dpa.component';
import { QuestionAndAnswerComponent } from './question-and-answer/question-and-answer.component';
import { VerifyComponent } from './verify/verify.component';
import { Verify2Component } from './verify2/verify2.component';
import { IndexComponent } from './index/index.component';
import { AllNewsComponent } from './all-news/all-news.component';
import { RegisterComponent } from './register/register.component';
import { ProfileComponent } from './profile/profile.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { StatusTrackingComponent } from './status-tracking/status-tracking.component';
import { RefundDepositsComponent } from './refund-deposits/refund-deposits.component';
import { StatusDocumentComponent } from './status-document/status-document.component';
import { LoginSocialComponent } from './login-social/login-social.component';
import { InvestigateComponent } from './investigate/investigate.component';
import { DownloadFileComponent } from './download-file/download-file.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { RequestDocumentComponent } from './request-document/request-document.component';
import { StatusRequestDocumentComponent } from './status-request-document/status-request-document.component';
import { TestndidComponent } from './testndid/testndid.component';
import { SinglegatewaywaitComponent } from './singlegatewaywait/singlegatewaywait.component';
import { Testndid2Component } from './testndid2/testndid2.component';
import { Singlegatewaywait2Component } from './singlegatewaywait2/singlegatewaywait2.component';
import { Singlegatewaywait3Component } from './singlegatewaywait3/singlegatewaywait3.component';
var appRoutes = [
    { path: '', redirectTo: 'mainmenu/index', pathMatch: 'full' },
    {
        path: 'mainmenu', component: MainmenuComponent,
        children: [
            { path: 'refund', component: RefundComponent },
            { path: 'financeInst', component: FinancialInstitutionComponent },
            { path: 'simulate', component: SimulatorComponent },
            { path: 'contactDPA', component: ContactDpaComponent },
            { path: 'faq', component: QuestionAndAnswerComponent },
            { path: 'verify', component: VerifyComponent },
            { path: 'verify2', component: Verify2Component },
            { path: 'index', component: IndexComponent },
            { path: 'reqNewDocument', component: RequestDocumentComponent },
            { path: 'statusReqNewDocument', component: StatusRequestDocumentComponent },
            { path: 'contact', component: ContactComponent },
            { path: 'contactReport', component: ContactReportComponent },
            { path: 'chatbot', component: ChatbotComponent },
            { path: 'socialMedia', component: SocialMediaMonitorComponent },
            { path: 'report', component: ReportComponent },
            { path: 'allNews', component: AllNewsComponent },
            { path: 'register', component: RegisterComponent },
            { path: 'login', component: LoginComponent },
            { path: 'profile', component: ProfileComponent },
            { path: 'forgotPassword', component: ForgotPasswordComponent },
            { path: 'statusDocument/:id', component: StatusDocumentComponent },
            { path: 'statusTracking', component: StatusTrackingComponent },
            { path: 'refundDeposits', component: RefundDepositsComponent },
            { path: 'aboutUs', component: AboutUsComponent }
        ]
    },
    {
        path: 'news/:id', component: NewsComponent
    },
    { path: 'resetPassword', component: ResetPasswordComponent },
    { path: 'resetpassword', component: ResetPasswordComponent },
    { path: 'loginSocial', component: LoginSocialComponent },
    { path: 'investigate', component: InvestigateComponent },
    { path: 'downloadFile', component: DownloadFileComponent },
    { path: 'login', component: LoginComponent },
    { path: 'Testndid', component: TestndidComponent },
    { path: 'Testndid2', component: Testndid2Component },
    { path: 'singlegatewaywait', component: SinglegatewaywaitComponent },
    { path: 'singlegatewaywait2', component: Singlegatewaywait2Component },
    { path: 'singlegatewaywait3', component: Singlegatewaywait3Component },
];
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };



// WEBPACK FOOTER //
// ./src/app/app.module.ts.pre-build-optimizer.js